
import { Component,  Vue } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import cloneDeep from 'lodash/cloneDeep';

@Component({})
export default class RecipientMethods extends Vue {
    public noRecipientsError: boolean = false;

    get recipientsIds(): any {
        return cloneDeep(this.$store.getters['Recipients/getRecipientsIds']);
    }

    get recipientsVisible(): boolean {
        return this.$store.getters['Recipients/getRecipientsVisible'];
    }

    get selectedRecipientsWithActionTargets(): any {
        return this.$store.getters['Recipients/getSelectedRecipientsWithActionTargets'];
    }

    get isTargetedRecipientListModalVisible(): boolean {
      return this.$store.getters['Recipients/isTargetedRecipientListModalVisible'];
    }

    get getTargetedRecipients(): any {
        return this.$store.getters['Recipients/getTargetedRecipients'];
    }

    public hasRecipients(recipients: any, ignoreCorporation: boolean = false): boolean {
        let isEmpty = false;

        for (const recipient in recipients) {
            if (ignoreCorporation && recipient === 'corporations') {
                continue;
            }

            if (recipients[recipient].length) {
                isEmpty = true;
                break;
            }
        }

        return isEmpty;
    }

    public recipientsVisibleContent(level: string, items: any) {
        if (level === 'projects') {
            if (items.length) {
                return items.length > 1
                    ? `${this.$t('general.project', 'Project')}: ${items.length} project selected`
                    : `${this.$t('general.project', 'Project')}: ${items[0].name}`;
            }
        }

        if (level === 'groups' || level === 'buildings') {
            if (items.length) {
                return items.length > 1
                    ? `${this.$t('general.unit-group', 'Unit group')}: ${items.length} unit group selected`
                    : `${this.$t('general.unit-group', 'Unit group')}: ${items[0].name}`;
            }
        }

        if (level === 'units' || level === 'properties') {
            if (items.length) {
                return items.length > 1
                    ? `${this.$t('general.unit', 'Unit')}: ${items.length} unit selected`
                    : `${this.$t('general.unit', 'Unit')}: ${this.propertyRecipientName(items[0])}`;
            }
        }

        if (level === 'corporations') {
            if (items.length) {
                return `${this.$t('general.corporation', 'Corporation')}: ${items[0].name}`;
            }
        }
    }

    public recipientsModal(recipientRequired: boolean = false) {
        this.noRecipientsError = false;

        this.$store.commit(Mutations.SET_RECIPIENTS_VISIBILITY, true);
        this.$store.commit(Mutations.SET_RECIPIENT_REQUIRED, recipientRequired);
    }

    public resetRecipients() {
        this.$store.commit(Mutations.RESET_RECIPIENTS);
    }

    public resetRecipient(level: string) {
        this.$store.commit(Mutations.RESET_RECIPIENT, level);
    }

    public propertyRecipientName(property) {
        if (typeof property.address === 'undefined') {
            return property.name;
        }

        if (typeof property.address === 'object') {
            return property.address.street;
        }

        return property.address;
    }

    /*
        This function fetches the targeted recipients and
        displays a modal with the tenants of the targeted entities.
    */
    public fetchTargetedRecipientsAndDisplayTheModal() {
        this.$store.dispatch(Actions.FETCH_TARGETED_RECIPIENTS);
        this.$store.commit(Mutations.SET_TARGETED_RECIPIENTS_MODAL_VISIBILITY, true);
    }
}
